// extracted by mini-css-extract-plugin
module.exports = {"box":"specie_box__2nUbQ","model":"specie_model__2__x7","back":"specie_back__22Dv8"};